
// Save enrollment data to localStorage
export function savePendingEnrollment(data: {
  courseId: string;
  price?: number;
  courseName?: string;
  username?: string;
  courseSlug?: string;
  from?: string;
}) {
  console.debug('[PendingEnrollment] Saving enrollment data:', data);
  localStorage.setItem('pendingEnrollment', JSON.stringify(data));
}

// Get enrollment data from localStorage
export function getPendingEnrollment() {
  const data = localStorage.getItem('pendingEnrollment');
  const parsed = data ? JSON.parse(data) : null;
  console.debug('[PendingEnrollment] Reading enrollment data:', parsed);
  return parsed;
}

// Clear enrollment data from localStorage
export function clearPendingEnrollment() {
  console.debug('[PendingEnrollment] Clearing enrollment data');
  localStorage.removeItem('pendingEnrollment');
}

// Get enrollment data from URL search params
export function getEnrollmentFromUrlParams(search: string) {
  const params = new URLSearchParams(search);
  const courseId = params.get('courseId');
  
  if (!courseId) {
    return null;
  }
  
  return {
    courseId,
    price: params.get('price') ? Number(params.get('price')) : undefined,
    courseName: params.get('courseName') ? decodeURIComponent(params.get('courseName')) : undefined,
    username: params.get('username') || undefined,
    courseSlug: params.get('courseSlug') || undefined,
    from: params.get('from') || undefined
  };
}

// For debugging: read and return the pending enrollment
export function readPendingEnrollment() {
  const data = localStorage.getItem('pendingEnrollment');
  return data ? JSON.parse(data) : null;
}

// Process pending enrollment after authentication if it exists
export async function processPendingEnrollmentIfExists() {
  const pendingEnrollment = getPendingEnrollment();
  console.debug('[PendingEnrollment] Processing pending enrollment if exists:', pendingEnrollment);
  
  if (!pendingEnrollment) {
    return null;
  }
  
  // We're not automatically clearing the pending enrollment here
  // to allow the calling function to decide when to do that
  // after it has successfully processed the enrollment
  
  return pendingEnrollment;
}
